import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { OverflowMenu } from 'ui/actionMenu/OverflowMenu';
import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Send } from 'ui/icons/action/Send';
import { View } from 'ui/icons/action/View';
import { spacing } from 'ui/theme';

import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { setParams } from 'utils/urlParams';

import { EventInfo, SystemEventName } from '../../../../domain';
import { TABLE_COLUMNS } from '../../constants';
import { useEventHistoryModalsContext } from '../../contexts/EventHistoryModalsContext';
import { Cell } from '../../../../components/table';
import { useUserKeyParameter } from '../../../../hooks';

const displayText = {
  resendMessage: 'Resend message',
  viewMessage: 'View message',
};

const StyledCell = styled(Cell)`
  && {
    text-align: right;
    min-width: ${spacing.double};
    box-sizing: content-box;
  }
`;

type EventHistoryOverflowMenuCellProps = {
  event: EventInfo;
};

export const EventHistoryOverflowMenuCell = ({
  event: { esDocumentId, eventType, campaign, createdAt },
}: EventHistoryOverflowMenuCellProps) => {
  const userKey = useUserKeyParameter(true);
  const { showResendMessageModal } = useEventHistoryModalsContext();
  const options: ActionMenuOption[] = [];
  const canViewMessage = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ViewMessaging,
  );
  if (campaign && esDocumentId && eventType === SystemEventName.emailSend) {
    if (canViewMessage) {
      options.push({
        as: AllowedActionMenuElements.Link,
        href: setParams('/triggered/viewSentEmail', {
          messageId: esDocumentId,
          recipient: userKey,
        }),
        content: (
          <>
            <View />
            <span>{displayText.viewMessage}</span>
          </>
        ),
        id: 'viewMessage',
        target: '_blank',
      });
    }

    options.push({
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Send />
          <span>{displayText.resendMessage}</span>
        </>
      ),
      id: 'resendMessage',
      onClick: () => showResendMessageModal({ campaign, messageId: esDocumentId }),
    });
  }
  return (
    <StyledCell columnId={TABLE_COLUMNS.OVERFLOW_MENU}>
      {!!options.length && (
        <OverflowMenu id={`event-history-overflow-${createdAt}`} options={options} />
      )}
    </StyledCell>
  );
};
